"use client";
import { useJwtToken } from "@website/hooks/auth-manager";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { isChannel } from "@website/utils/channel/helpers";
import { deepCompare } from "@website/utils/deep-compare";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { useLoginModal } from "@website/widget/login";
import { memo, useEffect } from "react";

export const Component = () => {
  const { onLoginModalOpen } = useLoginModal();
  const router = useCompatRouter();
  const { phoneNumber } = useJwtToken();
  const shouldNotShowPaths = ["shopping", "checkout", "profile"];

  useEffect(() => {
    const raw = localStorage.getItem("lastTimeWelcomeScreenShowed");
    const lastShow = raw ? new Date(raw).getTime() : 0;
    const diffSec = (Date.now() - lastShow) / 1000;
    if (
      diffSec >= 86_400 &&
      !phoneNumber &&
      isChannel(["android"]) &&
      shouldNotShowPaths.every((path) => !router?.pathname?.includes(path))
    ) {
      addEventToTracking(USER_TRACKING_EVENTS.APP_WELCOME_SCREEN_SHOWED, {
        product: "core"
      });
      setTimeout(() => {
        onLoginModalOpen({ isWelcomeScreen: true });
        setTimeout(() => {
          localStorage.setItem(
            "lastTimeWelcomeScreenShowed",
            new Date().toISOString()
          );
        }, 100);
      });
    }
  }, []);

  return null;
};
export const WelcomeScreenClientHandler = memo(Component, deepCompare);
